import React from 'react';
import Parser from 'html-react-parser';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';

function Hero8({ content }) {
    return (
            <section className="banner-section-three -type-12">
                <div className="bg-image">
                    <figure className="main-image wow fadeInRight" data-wow-delay="1500ms">
                        {content?.image[0] ? (<LazyLoadImage src={content.image[0].urlS3} alt={content.image[0].nom} effect="blur"/>) : ''}
                    </figure>
                    <div className="image-voile" style={{display: "none"}}></div>
                </div>

                <div className="auto-container">
                    <div className="row">
                        <div className="content-column col-lg-9 col-md-12 col-sm-12">
                            <div className="inner-column">
                                <div className="title-box wow fadeInUp">
                                    <h1 style={{marginTop: "30px"}}>
                                        {typeof content.titre === 'string' ? Parser(content.titre) : ''}
                                    </h1>
                                    <div className="text">
                                        {typeof content.description === 'string' ? Parser(content.description) : ''}
                                    </div>
                                </div>
                                {content?.button ?(
                                <a href={content.url} className="theme-btn btn-style-six mt-3">
                                    {content.button}
                                </a>
                                ) : ''}
                            </div>
                        </div>
                    </div>
                </div>
            </section>
    );
}

export default Hero8;
